export default "/assets/website/images/csoki-half.png?b5d3dc5da9ee3af90a4b71b05da21535";